module.exports = __webpack_public_path__ + "static/a-tale-of-love-and-darkness-d08bc9d7c1e440aed35005f1ecbe9424.jpg";